// import "../NewLesson.css";
import DropDown from "../../../../base/reusables/dropDown/DropDown";
import MobileDropDown from "../../../../base/reusables/mobileDropDown/MobileDropDown";
import MobileMultDropDown from "../../../../base/reusables/mobileMultDropDown/MobileMultDropDown";
import DropDownArrow from "../../../../base/icons/DropDownArrow";
import { InputLabel, FormControl, Grid, SwipeableDrawer, SelectChangeEvent } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../base/reusables/button/Button";
import Card from "../../../../base/reusables/card/Card";
import { Id, LessonDI, LessonFormObjectDI, SelectableDataObjectDI, } from "../../types";
import _ from "lodash";
import { useNavigate } from "react-router-dom";

import { observer } from "mobx-react";
import appStore from "../../../../base/stores/AppStore";
import { Autocomplete, TextField } from "@mui/material";

interface checkedItemsArr {
  id: string | number;
  checked: boolean;
}

interface base64Item {
  base64: File | HTMLCanvasElement | string;
  fileName: string;
  fileId?: string | number;
}

interface Doc {
  fileName: string;
  url: string;
  fileId?: string | number;
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     "& .MuiFormLabel-root": {
//       "@media (max-width: 960px)": {
//         position: "static",
//       },
//       marginTop: "-0.5rem",
//     },

//     "& .MuiFormHelperText-root": {
//       color: "red",
//     },
//   },
// }));

interface LessonFormPropsDI {
  availableValues: {
    allProjectName: Array<SelectableDataObjectDI>;
    allLessonField: Array<SelectableDataObjectDI>;
    allProjectType: Array<SelectableDataObjectDI>;
    allStep: Array<SelectableDataObjectDI>;
    allProjectPartners: Array<SelectableDataObjectDI>;
    allExternalFactorInvolved: Array<SelectableDataObjectDI>;
    allOrganizationalUnit: Array<SelectableDataObjectDI>;
    allLessonTags: Array<SelectableDataObjectDI>;
  };
  editedLesson?: LessonDI; //This will use the form in edit mode.
  onSubmit(lesson: LessonFormObjectDI): void;
  onErrorStateChange(hasError: boolean): void;
}

const LessonForm: React.FC<LessonFormPropsDI> = (props: LessonFormPropsDI) => {
  const MINIMUM_LENGTH = 2;
  const MAXIMUM_TITLE_LENGTH = 150;
  const MAXIMUM_SUBJECT_LENGTH = 700;
  const MAXIMUM_LESSON_LENGTH = 1000;
  const [lessonDocuments, setLessonDocuments] = useState<base64Item[]>([]);
  const [docsToDelete, setDocsToDelete] = useState<(string | number | undefined)[]>([]);

  useEffect(() => {
    if (props.editedLesson) setFormValues(props.editedLesson);
  }, [props.editedLesson]);

  
useEffect(() => {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/NewLesson.css";
  document.head.appendChild(link);

  return () => {
    document.head.removeChild(link);
  };
}, []);


  useEffect(() => {
    //  ValidatorForm.addValidationRule(
    //       "project-title",
    //       (value) => value.length <= MAXIMUM_TITLE_LENGTH
    //     );
    //     ValidatorForm.addValidationRule(
    //       "title",
    //       (value) => value.length <= MAXIMUM_TITLE_LENGTH
    //     );
    //     ValidatorForm.addValidationRule(
    //       "subject",
    //       (value) => value.length <= MAXIMUM_SUBJECT_LENGTH
    //     );
    //     ValidatorForm.addValidationRule(
    //       "lesson",
    //       (value) => value.length <= MAXIMUM_LESSON_LENGTH
    //     );
    //     ValidatorForm.addValidationRule(
    //       "minLength",
    //       (value) => value.length >= MINIMUM_LENGTH
    //     );
  }, []);

  const { availableValues, onSubmit } = props;
  const { allLessonField, allProjectType, allStep, allProjectPartners, allExternalFactorInvolved, allOrganizationalUnit, allLessonTags, } = availableValues;
  const { t } = useTranslation();
  const [projectTitle, setProjectTitle] = useState("");
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [fieldId, setFieldId] = useState("");
  const [fieldIsOpen, setFieldIsOpen] = useState(false);
  const [projectTypeId, setProjectTypeId] = useState("");
  const [projectTypeIsOpen, setProjectTypeIsOpen] = useState(false);
  const [stepId, setStepId] = useState("");
  const [projectStepIsOpen, setProjectStepIsOpen] = useState(false);
  const [externalFactorInvolvedId, setExternalFactorInvolvedId] = useState("");
  const [externalFactorInvolvedIsOpen, setExternalFactorInvolvedIsOpen] = useState(false); 
  const [organizationalUnitId, setOrganizationalUnitId] = useState("");
  const [organizationalUnitIdIsOpen, setOrganizationalUnitIdIsOpen] = useState(false);
  const [projectPartnerIds, setProjectPartners] = useState<Array<Id>>([]);
  const [projectPartnerIsOpen, setProjectPartnerIsOpen] = useState(false);
  const [subjectText, setSubjectText] = useState("");
  const [subjectError, setSubjectError] = useState("");

  const [lessonText, setLessonText] = useState("");
    const [lessonError, setLessonError] = useState("");

  const [lessonTags, setLessonTags] = useState<Array<Id>>([]);
  const [lessonTagsIsOpen, setLessonTagsIsOpen] = useState(false);
  const [filesTypeError, setFilesTypeError] = useState<boolean>(false);
  const [fieldIdError, setFieldIdError] = useState("");
  const [projectTypeIdError, setProjectTypeIdError] = useState("");
  const [stepIdError, setStepIdError] = useState("");

  const navigate = useNavigate();

  //Additional vlidations to what the validation library provides.
  const [listsErrors, setListsErrors] = useState<{ [listName: string]: { errorString: string; hasError: boolean }; }>({
    fieldId: {
      hasError: false,
      errorString: t("Lesson-new-lesson-required-list"),
    },
    projectTypeId: {
      hasError: false,
      errorString: t("Lesson-new-lesson-required-list"),
    },
    stepId: {
      hasError: false,
      errorString: t("Lesson-new-lesson-required-list"),
    },
  });

  const [textFieldsHaveError, setTextFieldsHaveError] = useState(false);

  const required_field = (label: string) => (
    <span>
      <span>{t(label)}</span>
      <span className="required_asterisk">*</span>
    </span>
  );

  const listsHaveError = useMemo(() => {
    for (let field in listsErrors) {
      if (listsErrors[field].hasError) {
        return true;
      }
    }
    return false;
  }, [listsErrors]);

  const hasError = useMemo(() => {
    if (textFieldsHaveError || listsHaveError) {
      props.onErrorStateChange(true);
      return true;
    }
    props.onErrorStateChange(false);
    return false;
  }, [textFieldsHaveError, listsHaveError]);

  const toggleListError = (listName: string, hasError: boolean) => {
    const modifiedListsErrors = _.cloneDeep(listsErrors);
    modifiedListsErrors[listName].hasError = hasError;
    setListsErrors(modifiedListsErrors);
  };

  const getListItemNamesFromIds = (list: typeof allProjectPartners, ids: Array<Id>) => {
    return _.chain(list)
      .keyBy("value")
      .at(ids)
      .value()
      .map((item) => item?.text ?? "");
  };

  const createTagsFromAllValues = (): Array<string> => {
    return [
      lessonText,
      title,
      subjectText,
      ...getListItemNamesFromIds(allProjectPartners, projectPartnerIds),
      ...getListItemNamesFromIds(allLessonTags, lessonTags),
      ...allOrganizationalUnit
        .filter((organizationalUnit) => organizationalUnit.value == organizationalUnitId)
        .map((organizationalUnit) => organizationalUnit.text),
      ...allExternalFactorInvolved
        .filter((externalFactor) => externalFactor.value == externalFactorInvolvedId)
        .map((externalFactor) => externalFactor.text),
      ...allLessonField
        .filter((lessonField) => lessonField.value == fieldId)
        .map((lessonField) => lessonField.text),
      ...allProjectType
        .filter((projectType) => projectType.value == projectTypeId)
        .map((projectType) => projectType.text),
      ...allStep
        .filter((step) => step.value == stepId)
        .map((step) => step.text),
    ];
  };

  const getListsWithErrors = () => {
    const fields: { [index: string]: boolean } = {
      stepId: !parseInt(stepId) ? true : false,
      fieldId: !parseInt(fieldId) ? true : false,
      projectTypeId: !parseInt(projectTypeId) ? true : false,
    };
    const fieldsWithErrors: string[] = [];

    for (let prop in fields) {
      if (fields[prop]) {
        fieldsWithErrors.push(prop);
      }
    }
    return fieldsWithErrors;
  };

  const setFieldsValidation = (listsWithErrors: Array<string>) => {
    const currentListsErrors = _.cloneDeep(listsErrors);
    for (let field of listsWithErrors) {
      currentListsErrors[field].hasError = true;
    }
    setListsErrors(currentListsErrors);
  };

  const handleSubmit = (e?: React.SyntheticEvent) => {
    e?.preventDefault();

    const isTitleValid = checkTitle(title) === "";
    const isSubjectValid = checkSubject(subjectText) === "";
    const isLessonValid = checkLesson(lessonText) === "";
    const isFieldIdValid = checkFieldId(fieldId) === "";
    const isStepIdValid = checkStepId(stepId) === "";
    const isProjectTypeIdValid = checkProjectTypeId(projectTypeId) === "";

    // לבדוק את כל הבדיקות
    if (isTitleValid && isSubjectValid && isLessonValid && isFieldIdValid && isStepIdValid && isProjectTypeIdValid) {

    const listsWithErrors = getListsWithErrors();
    if (listsWithErrors.length) {
      window.scrollTo(0, 0);
      return setFieldsValidation(listsWithErrors);
    }

    const tagsFromFields = createTagsFromAllValues().filter((tag) => tag !== "");

    const formObject: LessonFormObjectDI = {
      freeSearch: tagsFromFields,
      lessonText,
      fieldId,
      lessonTags,
      projectTitle,
      title,
      subjectText,
      lessonDocuments: lessonDocuments.filter((doc) => !doc.fileId),
      //organizationalUnitId: parseInt(organizationalUnitId),
     // externalFactorInvolvedId: parseInt(externalFactorInvolvedId),
      organizationalUnitId: organizationalUnitId ? parseInt(organizationalUnitId) : 0,
      externalFactorInvolvedId: externalFactorInvolvedId ? parseInt(externalFactorInvolvedId) : 0,
      projectPartnerIds,
      projectTypeId,
      stepId,
      docsToDelete,
    };

    onSubmit(formObject);
  }
  };

  const setFormValues = (lesson: LessonDI) => {
    setProjectTitle(lesson.projectTitle || "")
    setTitle(lesson.title);
    setFieldId(lesson.fieldId?.toString() || "");
    setProjectTypeId(lesson.projectTypeId?.toString() || "");
    setStepId(lesson.stepId?.toString() || "");
    setExternalFactorInvolvedId(lesson.externalFactorInvolvedId?.toString() || "");
    setOrganizationalUnitId(lesson.organizationalUnitId?.toString() || "");
    setProjectPartners(lesson.projectPartnerIds);
    setLessonTags(lesson.lessonTags);
    setSubjectText(lesson.subjectText);
    setLessonText(lesson.lessonText);
    convertToDocs(lesson.docs);
  };

  const convertToDocs = (docs: Array<Doc> | undefined) => {
    if (docs && docs.length) {
      let convertedDocs: Array<base64Item> = [];
      for (let i = 0; i < docs.length; i++) {
        let objToAdd = {
          fileName: docs[i].fileName,
          base64: docs[i].url,
          fileId: docs[i].fileId,
        };
        convertedDocs.push(objToAdd);
      }
      setLessonDocuments(convertedDocs);
    }
  };

  const mockForm = () => {
    setFormValues({
      projectTitle: t("Lesson-Form-AutoFill-mock-project-title"),
      title: t("Lesson-Form-AutoFill-mock-title"),
      fieldId: allLessonField[0].value,
      externalFactorInvolvedId: allExternalFactorInvolved[0].value,
      projectTypeId: allProjectType[1].value,
      organizationalUnitId: allOrganizationalUnit[0].value,
      lessonText: t("Lesson-Form-AutoFill-mock-lesson"),
      subjectText: t("Lesson-Form-AutoFill-mock-subject"),
      lessonTags: [allLessonTags[0].value],
      projectPartnerIds: [allProjectPartners[0].value.toString()],
      stepId: allStep[1].value,
    });
  };

  const setFocus = (errors: any) => document.getElementById(errors[0].props.id)?.focus();

  const handleLessonTagsChange = (checkedItems: checkedItemsArr[]) => {
    let tagsToSubmit = [];
    for (let i = 0; i < checkedItems.length; i++) {
      if (checkedItems[i].checked) {
        tagsToSubmit.push(checkedItems[i].id);
      }
    }
    if (lessonTagsIsOpen) {
      setLessonTagsIsOpen(false);
    }
    // toggleListError("lessonTags", false);
    setLessonTags(tagsToSubmit);
  };

  const handleProjectPartnersChange = (checkedItems: checkedItemsArr[]) => {
    let projectPartnersToSubmit = [];
    for (let i = 0; i < checkedItems.length; i++) {
      if (checkedItems[i].checked) {
        projectPartnersToSubmit.push(checkedItems[i].id);
      }
    }
    if (projectPartnerIsOpen) {
      setProjectPartnerIsOpen(false);
    }
    setProjectPartners(projectPartnersToSubmit);
  };

  const onFilesSelect = async (e: React.FormEvent<HTMLInputElement>) => {
    const fileObjects = (e.target as HTMLInputElement).files;
    const dataUrls = [...lessonDocuments];

    if (fileObjects && fileObjects.length) {
      for (let i = 0; i < fileObjects.length; i++) {
        let file = fileObjects[i];

        const isErrorFile = checkFile(file);
        if (isErrorFile) return;

        if (file.type === "image/png" || file.type === "image/jpeg") {
          const dataUrl = await decreaseImageSize(file, {
            maxWidth: appStore.imageMaxWidth,
            maxHeight: appStore.imageMaxHeight,
          });
          let objToAdd = {
            base64: dataUrl as HTMLCanvasElement,
            fileName: file.name,
          };
          dataUrls.push(objToAdd);
        } else {
          let base64 = await convertBase64(file);
          let objToAdd = {
            base64: base64 as HTMLCanvasElement,
            fileName: file.name,
          };
          dataUrls.push(objToAdd);
        }
      }
    }
    setLessonDocuments(dataUrls);
  };

  function decreaseImageSize(
    file: File,
    config = {
      maxWidth: appStore.imageMaxWidth,
      maxHeight: appStore.imageMaxHeight,
    }
  ) {
    return new Promise((resolve, reject) => {
      const blobURL = URL.createObjectURL(file);
      const img = new Image();
      img.src = blobURL;
      img.onerror = function () {
        URL.revokeObjectURL(this.src);
        reject("Cannot load image");
      };
      img.onload = function () {
        URL.revokeObjectURL((this as HTMLImageElement).src);
        const [newWidth, newHeight] = calculateSize(
          img,
          config.maxWidth,
          config.maxHeight
        );
        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0, newWidth, newHeight);
        resolve(canvas.toDataURL());
      };
    });
  }

  const acTagsSelectedValues = useMemo(() => {
    return allLessonTags.filter((item) =>
      lessonTags.includes(item.value.toString())
    );
  }, [lessonTags]);

  const acPatnersSelectedValues = useMemo(() => allProjectPartners.filter((item) => projectPartnerIds?.includes(item.value.toString())), [projectPartnerIds]);

  const selectableListAriaLabel = (
    selectableList: Array<SelectableDataObjectDI>
  ) => {
    let label = "";
    selectableList.map((val) => (label += val.text + " "));
    return label;
  };

  function calculateSize(img: any, maxWidth: number, maxHeight: number) {
    let width = img.width;
    let height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }
    }
    return [width, height];
  }

  const convertBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleDragEnter = (e: any) => {
    e.preventDefault();
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
  };

  const checkFile = (file: any) => {
    const fileTypesArr = [
      // .xlsx, .xls, image/jpeg, image/png, .doc, .docx, .pdf
      {
        extension: "doc",
        type: "application/msword",
      },
      {
        extension: "docx",
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
      {
        extension: "xlsx",
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      { extension: "xls", type: "application/vnd.ms-excel" },
      { extension: "png", type: "image/png" },
      { extension: "jpg", type: "image/jpeg" },
      { extension: "jpeg", type: "image/jpeg" },
      { extension: "pdf", type: "application/pdf" },
    ];
    const fileExtension = file.name.split(".").pop();
    const okFileCheck = fileTypesArr.find(
      (item) => item.extension === fileExtension && item.type === file.type
    );
    setFilesTypeError(!okFileCheck);
    return !okFileCheck;
  };

  const handleDrop = async (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    let dataUrls = [...lessonDocuments];

    const isErrorFile = checkFile(file);
    if (isErrorFile) return;

    if (file && file.name.length) {
      if (file.type === "image/png" || file.type === "image/jpeg") {
        const dataUrl = await decreaseImageSize(file, {
          maxWidth: 100,
          maxHeight: 100,
        });
        let objToAdd = {
          base64: dataUrl as HTMLCanvasElement,
          fileName: file.name,
        };
        dataUrls.push(objToAdd);
      } else {
        let base64 = await convertBase64(file);
        let objToAdd = {
          base64: base64 as HTMLCanvasElement,
          fileName: file.name,
        };
        dataUrls.push(objToAdd);
      }
    }
    setLessonDocuments(dataUrls);
  };
 
  const handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSubjectText(e.target.value);
    checkSubject(e.target.value);
  };
  const checkSubject = (value: any) => {
    setSubjectError("");
    if (!value) {
      setSubjectError(t("Lesson-new-lesson-subject-error"));
      return t("Lesson-new-lesson-subject-error");
    }
    if (value.length < MINIMUM_LENGTH) {
      setSubjectError(t("Minimal-length"));
      return t("Minimal-length");
    }
    if (value.length >= MAXIMUM_SUBJECT_LENGTH) {
      setSubjectError(t("Maximal-length")+' ' +MAXIMUM_SUBJECT_LENGTH);
      return t("Maximal-length")+' ' +MAXIMUM_SUBJECT_LENGTH;
    }
    return "";
  }

  const handleLessonChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setLessonText(e.target.value);
    checkLesson(e.target.value);
  };
  const checkLesson = (value: any) => {
    setLessonError("");
    if (!value) {
      setLessonError(t("Lesson-new-lesson-lesson-error"));
      return t("Lesson-new-lesson-lesson-error");
    }
    if (value.length <= MINIMUM_LENGTH) {
      setLessonError(t("Minimal-length"));
      return t("Minimal-length");
    }
    if (value.length >= MAXIMUM_LESSON_LENGTH) {
      setLessonError(t("Maximal-length")+' ' +MAXIMUM_LESSON_LENGTH);
      return t("Maximal-length")+' ' +MAXIMUM_LESSON_LENGTH;
    }
    return "";
  } 
   const handleFieldIdChange = (e: SelectChangeEvent<string | number | (string | number)[]>) => { 
    toggleListError("fieldId", false);
    setFieldId(e.target.value as string);
    checkFieldId(e.target.value);
  };
  const checkFieldId = (value: any) => {
    setFieldIdError("");
    if (!value) {
      setFieldIdError(t("Lesson-new-lesson-required-list"));
      return t("Lesson-new-lesson-required-list");
    }
    return "";
  }
  const handleStepIdChange = (e: SelectChangeEvent<string | number | (string | number)[]>) => { 
    toggleListError("fieldId", false);
    setStepId(e.target.value as string);
    checkStepId(e.target.value);
  };
  const checkStepId = (value: any) => {
    setStepIdError("");
    if (!value) {
      setStepIdError(t("Lesson-new-lesson-required-list"));
      return t("Lesson-new-lesson-required-list");
    }
    return "";
  }
    const handleProjectTypeIdChange = (e: SelectChangeEvent<string | number | (string | number)[]>) => { 
      toggleListError("projectTypeId", false);
      setProjectTypeId(e.target.value as string);
      checkProjectTypeId(e.target.value);
    };
    const checkProjectTypeId = (value: any) => {
      setProjectTypeIdError("");
      if (!value) {
        setProjectTypeIdError(t("Lesson-new-lesson-required-list"));
        return t("Lesson-new-lesson-required-list");
      }
      return "";
    }


  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setTitle(e.target.value);
    checkTitle(e.target.value);
  };
  const checkTitle = (value: any) => {
    setTitleError("");
    if (!value) {
      setTitleError(t("Lesson-new-lesson-project-title-error"));
      return t("Lesson-new-lesson-project-title-error");
    }
    if (value.length <= MINIMUM_LENGTH) {
      setTitleError(t("Minimal-length"));
      return t("Minimal-length");
    }
    if (value.length >= MAXIMUM_TITLE_LENGTH) {
      setTitleError(t("Maximal-length")+' ' +MAXIMUM_TITLE_LENGTH);
      return t("Maximal-length")+' ' +MAXIMUM_TITLE_LENGTH;
    }
return "";
  }

  const removeDoc = (index: number) => {
    let newDocumentList = [...lessonDocuments];
    newDocumentList.splice(index, 1);
    if (props.editedLesson && lessonDocuments[index].fileId) {
      let newDocsToDelete = [...docsToDelete];
      newDocsToDelete.push(lessonDocuments[index].fileId);
      setDocsToDelete(newDocsToDelete);
    }
    setLessonDocuments(newDocumentList);
  };

  return (
    <form
      noValidate
      onSubmit={(e) => {
        setTextFieldsHaveError(false);
        handleSubmit(e);
      }}
      onError={(e) => {
        window.scrollTo(0, 0);
        setTextFieldsHaveError(true);
        const errors = getListsWithErrors();
        if (errors.length) {
          setFieldsValidation(errors);
        }
        setFocus(e);
      }}
    >
      <div className={'cardWrapper'}>
        <Card
          title={t("Lesson-header")}
          body={
            <React.Fragment>
              <Grid container direction="row">
                {/* <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  lg={8}
                  item
                >
                  <div className={'newLesson__textField'}>
                    <TextField
                     // validators={["required", "project-title", "minLength"]}
                      // errorMessages={[
                      //   t("Lesson-new-lesson-project-title-error"),
                      //   t("Maximal-length") + ": " + MAXIMUM_TITLE_LENGTH,
                      //   t("Minimal-length"),
                      // ]}
                        className="custom-text-field"
                      variant="standard"
                      name="Lesson-project-title"
                      value={projectTitle}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setProjectTitle(e.target.value);
                      }}
                      fullWidth
                      id="Lesson-project-title"
                      label={required_field("Lesson-project-title")}
                    />
                  </div>
                </Grid> */}
                <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  lg={8}
                  item
                >
                  <div className={'newLesson__textField'}>
                    <TextField
                      // validators={["required", "title", "minLength"]}
                      // errorMessages={[
                      //   t("Lesson-new-lesson-title-error"),
                      //   t("Maximal-length") + ": " + MAXIMUM_TITLE_LENGTH,
                      //   t("Minimal-length"),
                      // ]}
                      error={!!titleError}
                      helperText={titleError}
                      className="custom-text-field"
                      variant="standard"
                      name="Lesson-title"
                      value={title}
                      onChange={handleTitleChange}
                      fullWidth
                      id="Lesson-title"
                      label={required_field("Lesson-title")}
                    />
                  </div>
                </Grid>
                <Grid className={'newLesson__item newLesson__item__padded'} xs={12} lg={4} item>
                  <div className={'newLesson__select'}>
                    <FormControl className={`${'formControl'} root`}>
                      <InputLabel
                        id="Lesson-field-label"
                        //  className={classes.root}
                        className="custom-text-field"
                        variant="standard"
                      >
                        {t("Lesson-field")}
                        <span className="required_asterisk">*</span>
                      </InputLabel>
                      {!appStore.isMobileResolution || !fieldIsOpen ? (
                        <div className={'dropDownWrapper'}>
                          <DropDown

                            ariaLabel={t("Lesson-field")}
                            hasError={!!fieldIdError}
                            errorString={fieldIdError}
                            id="Lesson-field"
                            labelId="Lesson-field-label"
                            value={fieldId} 
                            onChange={(e) => {
                              handleFieldIdChange(e)
                            }}
                           
                            items={allLessonField.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          {appStore.isMobileResolution ? (
                            <button
                              onClick={() => setFieldIsOpen(true)}
                              className={'mobile__button__open'}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <>
                          <DropDown
                            id="Lesson-field"
                            ariaLabel={t("Lesson-field")}
                            labelId="Lesson-field-label"
                            value={fieldId}
                            items={allLessonField.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          <SwipeableDrawer
                            anchor={"bottom"}
                            open={fieldIsOpen}
                            onClose={() => setFieldIsOpen(false)}
                            onOpen={() => setFieldIsOpen(true)}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{
                              backgroundColor: "rgba(0, 15, 30, 0.81)",  // השתמש ב-sx במקום style
                            }}                          >
                            <MobileDropDown
                              hasError={!!fieldIdError}
                              errorString={fieldIdError}
                              id="Lesson-field"
                              labelId="Lesson-field-label"
                              value={fieldId}
                              onClick={(e) => {
                                setFieldIsOpen(false);
                                handleFieldIdChange
                              }}
                                                         
                              changeOpen={() => setFieldIsOpen(false)}
                              items={allLessonField.filter((el) => {
                                return el.hide === false;
                              })}
                              open={fieldIsOpen}
                              title={t("Lesson-Form-Field-title")}
                            />
                          </SwipeableDrawer>
                        </>
                      )}
                    </FormControl>
                  </div>
                </Grid>

                <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  lg={4}
                  item
                >
                  <div className={'newLesson__select'}>
                    <FormControl className={'formControl'}>
                      <InputLabel id="Lesson-project-label">
                        {t("Lesson-project-type")}
                        <span className="required_asterisk">*</span>
                      </InputLabel>
                      {!appStore.isMobileResolution || !projectTypeIsOpen ? (
                        <div className={'dropDownWrapper'}>
                          <DropDown
                            hasError={!!projectTypeIdError}
                            errorString={projectTypeIdError}
                            id="Lesson-project"
                            ariaLabel={t("Lesson-project-type")}
                            labelId="Lesson-project-label"
                            value={projectTypeId}
                            onChange={(e) => {
                              handleProjectTypeIdChange(e)
                            }}
                            items={allProjectType.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          {appStore.isMobileResolution ? (
                            <button
                              onClick={() => setProjectTypeIsOpen(true)}
                              className={'mobile__button__open'}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <>
                          <DropDown
                            id="Lesson-project"
                            labelId="Lesson-project-label"
                            ariaLabel={t("Lesson-project-type")}
                            value={projectTypeId}
                            onChange={(e) => { }}
                            items={allProjectType.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          <SwipeableDrawer
                            anchor={"bottom"}
                            open={projectTypeIsOpen}
                            onClose={() => setProjectTypeIsOpen(false)}
                            onOpen={() => setProjectTypeIsOpen(true)}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{ backgroundColor: "rgba(0, 15, 30, 0.81)" }}

                          >
                            {" "}
                            <MobileDropDown
                                hasError={!!projectTypeIdError}
                                errorString={projectTypeIdError}
                              id="Lesson-project"
                              labelId="Lesson-project-label"
                              value={projectTypeId}
                              onChange={(e) => {
                                setProjectTypeIsOpen(false);
                                handleProjectTypeIdChange(e as SelectChangeEvent<string | number | (string | number)[]>);
                              }}
                              
                              onClick={(e) => {
                                setProjectTypeIsOpen(false);
                                toggleListError("projectTypeId", false);
                                setProjectTypeId(String(e.currentTarget.value));
                              }}
                              changeOpen={() => setProjectTypeIsOpen(false)}
                              items={allProjectType.filter((el) => {
                                return el.hide === false;
                              })}
                              open={projectTypeIsOpen}
                              title={t("Lesson-Form-ProjectType-title")}
                            />
                          </SwipeableDrawer>
                        </>
                      )}
                    </FormControl>
                  </div>
                </Grid>
                <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  lg={4}
                  item
                >
                  <div className={'newLesson__select'}>
                    <FormControl className={'formControl'}>
                      <InputLabel id="Lesson-project-step-label">
                        {t("Lesson-project-step")}
                        <span className="required_asterisk">*</span>
                      </InputLabel>

                      {!appStore.isMobileResolution || !projectStepIsOpen ? (
                        <div className={'dropDownWrapper'}>
                          <DropDown
                            hasError={!!stepIdError}
                            errorString={stepIdError}
                            id="Lesson-project-step"
                            labelId="Lesson-project-step-label"
                            ariaLabel={t("Lesson-project-step")}
                            value={stepId}
                            onChange={(e) => handleStepIdChange(e)}

                            items={allStep.filter((el) => {
                              return el.hide === false;
                            })}
                          />{" "}
                          {appStore.isMobileResolution ? (
                            <button
                              onClick={() => setProjectStepIsOpen(true)}
                              className={'mobile__button__open'}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <>
                          {" "}
                          <DropDown
                            id="Lesson-project-step"
                            labelId="Lesson-project-step-label"
                            ariaLabel={t("Lesson-project-step")}
                            value={stepId}
                            onChange={(e) => { }}
                            items={allStep.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          <SwipeableDrawer
                            anchor={"bottom"}
                            open={projectStepIsOpen}
                            onClose={() => setProjectStepIsOpen(false)}
                            onOpen={() => setProjectStepIsOpen(true)}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{ backgroundColor: "rgba(0, 15, 30, 0.81)" }}
                          >
                            {" "}
                            <MobileDropDown
                             hasError={!!stepIdError}
                             errorString={stepIdError}
                              id="Lesson-project-step"
                              labelId="Lesson-project-step-label"
                              value={stepId}
                              onClick={(e) => {
                                handleStepIdChange({ target: { value: stepId } } as SelectChangeEvent<string | number | (string | number)[]>);
                                setProjectStepIsOpen(false);
                                
                              }}
                              changeOpen={() => setProjectStepIsOpen(false)}
                              items={allStep.filter((el) => {
                                return el.hide === false;
                              })}
                              open={projectStepIsOpen}
                              title={t("Lesson-project-step")}
                            />
                          </SwipeableDrawer>
                        </>
                      )}
                    </FormControl>
                  </div>
                </Grid>

                <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  item
                  lg={4}
                >
                  <div className={'newLesson__select'}>
                    <FormControl className={'formControl'}>
                      <InputLabel id="Lesson-external-factor-involved-label">
                        {t("Lesson-external-factor-involved")}
                      </InputLabel>

                      {!appStore.isMobileResolution ||
                        !externalFactorInvolvedIsOpen ? (
                        <div className={'dropDownWrapper'}>
                          <DropDown
                            id="Lesson-external-factor-involved"
                            labelId="Lesson-external-factor-involved-label"
                            ariaLabel={t("Lesson-external-factor-involved")}
                            value={externalFactorInvolvedId}
                            onChange={(e) => {
                              setExternalFactorInvolvedId(e.target.value as string);
                            }}
                            items={allExternalFactorInvolved.filter((el) => {
                              return el.hide === false;
                            })}
                          />{" "}
                          {appStore.isMobileResolution ? (
                            <button
                              onClick={() =>
                                setExternalFactorInvolvedIsOpen(true)
                              }
                              className={'mobile__button__open'}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <>
                          <DropDown
                            id="Lesson-external-factor-involved"
                            labelId="Lesson-external-factor-involved-label"
                            ariaLabel={t("Lesson-external-factor-involved")}
                            value={externalFactorInvolvedId}
                            items={allExternalFactorInvolved.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          <SwipeableDrawer
                            anchor={"bottom"}
                            open={externalFactorInvolvedIsOpen}
                            onClose={() =>
                              setExternalFactorInvolvedIsOpen(false)
                            }
                            onOpen={() => setExternalFactorInvolvedIsOpen(true)}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{ backgroundColor: "rgba(0, 15, 30, 0.81)" }}
                          >
                            <MobileDropDown
                              id="Lesson-external-factor-involved"
                              labelId="Lesson-external-factor-involved-label"
                              value={externalFactorInvolvedId}
                              onClick={(e) => {
                                setExternalFactorInvolvedIsOpen(false);
                                setExternalFactorInvolvedId(
                                  String(e.currentTarget.value)
                                );
                              }}
                              changeOpen={() =>
                                setExternalFactorInvolvedIsOpen(false)
                              }
                              items={allExternalFactorInvolved.filter((el) => {
                                return el.hide === false;
                              })}
                              open={externalFactorInvolvedIsOpen}
                              title={t(
                                "Lesson-Form-ExternalFactorInvolved-title"
                              )}
                            />
                          </SwipeableDrawer>
                        </>
                      )}
                    </FormControl>
                  </div>
                </Grid>
                <Grid
                  className={'newLesson__item__padded'}
                  xs={12}
                  item
                  lg={4}
                >
                  <div className={'newLesson__select'}>
                    <FormControl className={'formControl'}>
                      <InputLabel id="Lesson-organizational-unit-involved-label">
                        {t("Lesson-organizational-unit-involved")}
                      </InputLabel>

                      {!appStore.isMobileResolution ||
                        !organizationalUnitIdIsOpen ? (
                        <div className={'dropDownWrapper'}>
                          <DropDown
                            id="Lesson-organizational-unit-involved"
                            labelId="Lesson-organizational-unit-involved-label"
                            ariaLabel={t("Lesson-organizational-unit-involved")}
                            value={organizationalUnitId}
                            onChange={(e) => {
                              setOrganizationalUnitId(e.target.value as string);
                            }}
                            items={allOrganizationalUnit.filter((el) => {
                              return el.hide === false;
                            })}
                          />{" "}
                          {appStore.isMobileResolution ? (
                            <button
                              onClick={() =>
                                setOrganizationalUnitIdIsOpen(true)
                              }
                              className={'mobile__button__open'}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <>
                          {" "}
                          <DropDown
                            id="Lesson-organizational-unit-involved"
                            labelId="Lesson-organizational-unit-involved-label"
                            ariaLabel={t("Lesson-organizational-unit-involved")}
                            value={organizationalUnitId}
                            onChange={(e) => { }}
                            items={allOrganizationalUnit.filter((el) => {
                              return el.hide === false;
                            })}
                          />
                          <SwipeableDrawer
                            anchor={"bottom"}
                            open={organizationalUnitIdIsOpen}
                            onClose={() => setOrganizationalUnitIdIsOpen(false)}
                            onOpen={() => setOrganizationalUnitIdIsOpen(true)}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{ backgroundColor: "rgba(0, 15, 30, 0.81)" }}
                          >
                            <MobileDropDown
                              id="Lesson-organizational-unit-involved"
                              labelId="Lesson-organizational-unit-involved-label"
                              value={organizationalUnitId}
                              onClick={(e) => {
                                setOrganizationalUnitIdIsOpen(false);
                                setOrganizationalUnitId(
                                  String(e.currentTarget.value)
                                );
                              }}
                              changeOpen={() =>
                                setOrganizationalUnitIdIsOpen(false)
                              }
                              items={allOrganizationalUnit.filter((el) => {
                                return el.hide === false;
                              })}
                              open={organizationalUnitIdIsOpen}
                              title={t("Lesson-Form-OrganizedUnit-title")}
                            />
                          </SwipeableDrawer>
                        </>
                      )}
                    </FormControl>
                  </div>
                </Grid>
                <Grid className={'newLesson__partners '} container>
                  <Grid
                    className={'newLesson__item__padded__select'}
                    xs={12}
                    item
                    lg={4}
                  >
                    <div className={'newLesson__select'}>
                      <FormControl className={'formControl'}>
                        <InputLabel
                          aria-label={t("Lesson-project-partners")}
                          role="label"
                          tabIndex={0}
                          id="demo-simple-select-label"
                        >
                          {t("Lesson-project-partners")}
                        </InputLabel>
                        <br />
                        {!appStore.isMobileResolution || !projectPartnerIsOpen ? (
                          <div className={'dropDownWrapper'}>
                            <Autocomplete
                              aria-label={selectableListAriaLabel(acPatnersSelectedValues)}
                              multiple
                              openOnFocus={true}
                              id="checkboxes-tags-demo4"
                              options={allProjectPartners.filter((el) => {
                                return el.hide === false;
                              })}
                              popupIcon={<DropDownArrow />}
                              value={acPatnersSelectedValues}
                              disableCloseOnSelect
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                              onChange={(e, selectedItems) => {
                                const checkedIds = selectedItems.map((i) => i.value.toString());
                                const unCheckedIds = allProjectPartners
                                  .filter((i) => !checkedIds.includes(i as any))
                                  .map((i) => ({
                                    id: i.value.toString(),
                                    checked: false,
                                  }));
                                const checked = checkedIds.map((c) => ({
                                  checked: true,
                                  id: c,
                                }));
                                handleProjectPartnersChange([
                                  ...checked,
                                  ...unCheckedIds,
                                ]);
                              }}
                              getOptionLabel={(option) => option?.text}
                              renderOption={(props, option, { selected }) => {
                                return (
                                  <>
                                    <li {...props}>
                                      <input
                                        checked={projectPartnerIds.includes(
                                          option.value.toString()
                                        )}
                                        type="checkbox"
                                      />
                                      <span className={'optionText'}>
                                        {option?.text}
                                      </span>
                                    </li>
                                    <hr className={'bottomHr'} />
                                  </>
                                );
                              }}
                              style={{
                                width: "100%",
                                height: "100%",
                                padding: "20px 0px 20px 0px",
                                textAlign: "right",
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  variant="standard"
                                />
                              )}
                            />
                            {appStore.isMobileResolution ? (
                              <button
                                onClick={() => setProjectPartnerIsOpen(true)}
                                className={'mobile__button__open'}
                              />
                            ) : null}
                          </div>
                        ) : (
                          <>
                            <MobileMultDropDown
                              value={projectPartnerIds}
                              items={allProjectPartners.filter((el) => {
                                return el.hide === false;
                              })}
                              labelId="Lesson-project-partners-label"
                              onChange={handleProjectPartnersChange}
                              checkedItems={projectPartnerIds}
                              open={projectPartnerIsOpen}
                              title={t("Lesson-Form-Partners-title")}
                              callBackSetter={setProjectPartnerIsOpen}
                            />
                          </>
                        )}
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          }
        />
      </div>

      <div className={'cardWrapper'}>
        <Card
          title={t("Lesson-subject-text")}
          body={
            <div className={`${'newLesson__textField'}  root`}>
              <TextField
                //className={classes.root}
                name="Lesson-subject-placeholder"
                // validators={["required", "subject", "minLength"]}
                // errorMessages={[
                //   t("Lesson-new-lesson-subject-error"),
                //   t("Maximal-length") + ": " + MAXIMUM_SUBJECT_LENGTH,
                //   t("Minimal-length"),
                // ]}
                error={!!subjectError}
                helperText={subjectError}
                className="custom-text-field"
                variant="standard"
                multiline
                value={subjectText}
                onChange={handleSubjectChange           }
                fullWidth
                id="Lesson-subject-placeholder"
                label={required_field("Lesson-subject-placeholder")}
              />
            </div>
          }
        />
      </div>

      <div className={'cardWrapper'}>
        <Card
          title={t("Lesson-lesson-text")}
          body={
            <div className={`${'newLesson__textField'} root`}>
              <TextField
                // className={classes.root}
                // validators={["required", "lesson", "minLength"]}
                // errorMessages={[
                //   t("Lesson-new-lesson-lesson-error"),
                //   t("Maximal-length") + ": " + MAXIMUM_LESSON_LENGTH,
                //   t("Minimal-length"),
                // ]}
                error={!!lessonError}
                helperText={lessonError}
                className="custom-text-field"
                variant="standard"
                name="Lesson-lesson-text-placeholder"
                multiline
                value={lessonText}
                onChange={handleLessonChange}
                 
                fullWidth
                id="Lesson-lesson-text-placeholder"
                label={required_field("Lesson-lesson-text-placeholder")}
              />
            </div>
          }
        />
      </div>

      <div className={'cardWrapper'}>
        <Card
          title={t("Lesson-tags-header")}
          body={
            <Grid container>
              <Grid
                className={'newLesson__item__padded__select'}
                item
                xs={12}
                lg={4}
              >
                <div className={'newLesson__select'}>
                  <FormControl className={'formControl'}>
                    <InputLabel tabIndex={0} id="Lesson-tags-placeholder-label">
                      {t("Lesson-tags-placeholder")}
                    </InputLabel>
                    <br />
                    {!appStore.isMobileResolution || !lessonTagsIsOpen ? (
                      <div className={'dropDownWrapper'}>
                        <Autocomplete
                          multiple
                          aria-label={selectableListAriaLabel(
                            acTagsSelectedValues
                          )}
                          openOnFocus={true}
                          id="checkboxes-tags-demo2"
                          options={allLessonTags.filter((el) => {
                            return el.hide === false;
                          })}
                          popupIcon={<DropDownArrow />}
                          value={acTagsSelectedValues}
                          disableCloseOnSelect
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                          onChange={(e, selectedItems) => {
                            const checkedIds = selectedItems.map((i) =>
                              i.value.toString()
                            ); //Get all checked ids
                            const unCheckedIds = allLessonTags
                              .filter((i) => !checkedIds.includes(i as any))
                              .map((i) => ({
                                id: i.value.toString(),
                                checked: false,
                              }));
                            const checked = checkedIds.map((c) => ({
                              checked: true,
                              id: c,
                            })); //Create "checkedItemsArr"

                            handleLessonTagsChange([
                              ...checked,
                              ...unCheckedIds,
                            ]);
                          }}
                          getOptionLabel={(option) => option.text}
                          renderOption={(props, option, { selected }) => {
                            return (
                              <>
                                <li {...props}>
                                  <input
                                    checked={lessonTags.includes(
                                      option.value.toString()
                                    )}
                                    type="checkbox"
                                  />
                                  <span className={'optionText'}>
                                    {option.text}
                                  </span>
                                </li>
                                <hr className={'bottomHr'} />
                              </>
                            );
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            padding: "20px 0px 20px 0px",
                            textAlign: "right",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder=""
                              variant="standard"
                            />
                          )}
                        />
                        {appStore.isMobileResolution ? (
                          <button
                            onClick={() => setLessonTagsIsOpen(true)}
                            className={'mobile__button__open'}
                          />
                        ) : null}
                      </div>
                    ) : (
                      <>
                        <MobileMultDropDown
                          value={lessonTags}
                          items={allLessonTags.filter((el) => {
                            return el.hide === false;
                          })}
                          labelId="Lesson-tags-placeholder-label"
                          onChange={handleLessonTagsChange}
                          checkedItems={lessonTags}
                          open={lessonTagsIsOpen}
                          title={t("Lesson-Form-Tags-title")}
                          callBackSetter={setLessonTagsIsOpen}
                        />
                      </>
                    )}
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          }
        />
      </div>

      <Grid container>
        <Grid item xs={12}>
          <div className={'newLesson__buttonWrapper'}>
            <div className={'newLesson__button'}>
              <Button aria-label={t("Lesson-submit")} type="submit">
                {t("Lesson-submit")}
              </Button>
            </div>
            <div className={'newLesson__button_white'}>
              <Button
              
                aria-label={t("Lesson-cancel")}
                variant="empty"
                onClick={() => navigate(-1)}
              >
                {t("Lesson-cancel")}
              </Button>
            </div>
            {/* {(["development", "qa"].includes(process.env.REACT_APP_ENV ?? "") || document.location.href.includes("israrail-development-front.azurewebsites.net")) && (
              <div className={'newLesson__button'}>
                <Button
                  aria-label={t("Lesson-Form-AutoFill-button")}
                  variant="empty"
                  onClick={mockForm}
                >
                  {t("Lesson-Form-AutoFill-button")}
                </Button>
              </div>
            )} */}
          </div>
        </Grid>
      </Grid>
    </form>
  );
};

export default observer(LessonForm);
